// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__3CF6U","contained":"OpenButton_contained__xFXY_","disabled":"OpenButton_disabled__2FUmG","error":"OpenButton_error__36mMd"};